module.exports = {
    da: {
        '%': '%',
        Coach: 'Træner',
        Defender: 'Forsvar',
        Forward: 'Angriber',
        Goalkeeper: 'Målmand',
        Midfielder: 'Midtbane',
        all: 'Alle',
        assist: 'Assist',
        assists: 'Assists',
        at: 'kl.',
        attempts: 'Afslutninger',
        averageShots: 'Skud pr. kamp',
        'averageStats.aerialDuels.percentage': 'Luftdueller, % pr. kamp',
        'averageStats.aerialDuels.total': 'Luftdueller pr. kamp',
        'averageStats.aerialDuels.won': 'Luftdueller vundet pr. kamp',
        'averageStats.assists': 'Assister per kamp',
        'averageStats.ballsWon': 'Erobringer pr. kamp',
        'averageStats.blocks': 'Blokeringer pr. kamp',
        'averageStats.catches': 'Grebne bolde pr. kamp',
        'averageStats.chancesCreated': 'Chancer skabt pr. kamp',
        'averageStats.clears': 'Clearinger per kamp',
        'averageStats.cornerKicks': 'Hjørnespark per kamp',
        'averageStats.crossBreakdown.percentage': 'Succesfulde indlæg (%) per kamp',
        'averageStats.crossBreakdown.successful': 'Succesfulde indlæg pr. kamp',
        'averageStats.crosses': 'Indlæg per kamp',
        'averageStats.distanceData.averageSpeed': 'Gennemsnitlig hastighed pr kamp',
        'averageStats.distanceData.distance': 'Meter løbet pr kamp',
        'averageStats.distanceData.sprintAverageLength': 'Gns. sprint længte per kamp',
        'averageStats.distanceData.sprints': 'Sprinter pr. kamp',
        'averageStats.distanceData.sprintsDistance': 'Sprint distance pr. kamp',
        'averageStats.distanceData.topSpeed': 'Top hastighed pr. kamp',
        'averageStats.foulsCommitted': 'Frispark begået pr. kamp',
        'averageStats.foulsSuffered': 'Frispark trukket pr. kamp',
        'averageStats.goalPerShot': 'Mål pr. skud',
        'averageStats.goals': 'Mål pr. kamp',
        'averageStats.groundDuels.percentage': 'Dueller, % vundet pr. kamp',
        'averageStats.groundDuels.total': 'Dueller vundet pr. kamp',
        'averageStats.groundDuels.won': 'Dueller vundet pr. kamp',
        'averageStats.keyPasses': 'Nøgle afleveringer',
        'averageStats.matchesPlayed': 'Kampe spillet',
        'averageStats.minutesPlayed': 'Minutter pr. kamp',
        'averageStats.missedPenalty': 'Brændte straffespark pr. kamp',
        'averageStats.offsides': 'Offsides pr. match',
        'averageStats.ownGoals': 'Selvmål pr. kamp',
        'averageStats.passLength.long': 'Lange afl. pr. kamp',
        'averageStats.passLength.short': 'Korte afl. pr. kamp',
        'averageStats.penaltyKicks.goals': 'Straffespark scoret pr. kamp',
        'averageStats.penaltyKicks.shots': 'Straffespark begået pr. kamp',
        'averageStats.penaltyKicks.won': 'Straffespark trukket pr. kamp',
        'averageStats.possessionAdvanced': 'Gns. boldbesiddelse',
        'averageStats.rating': 'Karakter, gennemsnit',
        'averageStats.redCards': 'Røde kort pr. kamp',
        'averageStats.saves': 'Redninger pr. kamp',
        'averageStats.savesPercentage': 'Gns. Redningsprocent',
        'averageStats.score': 'Mål pr. kamp',
        'averageStats.shots': 'Skud pr. kamp',
        'averageStats.shotsFaced': 'Skud imod pr. kamp',
        'averageStats.shotsOnGoal': 'Skud på mål pr. kamp',
        'averageStats.shotsOnGoalFaced': 'Skud på mål imod pr. kamp',
        'averageStats.substitutionsIn': 'Indskiftninger',
        'averageStats.substitutionsOut': 'Udskiftninger',
        'averageStats.tackles': 'Tacklinger pr. kamp',
        'averageStats.touches.blocks': 'Blokeringer pr. kamp',
        'averageStats.touches.completedPasses': 'Succ. afleveringer pr. kamp',
        'averageStats.touches.completionPercentage': 'Succ. afleveringer % pr. kamp',
        'averageStats.touches.interceptions': 'Erobringer pr. kamp',
        'averageStats.touches.passes': 'Afleveringer pr. kamp',
        'averageStats.touches.passesReceived': 'Modtaget afleveringer pr. kamp',
        'averageStats.touches.total': 'Berøringer pr. kamp',
        'averageStats.yellowCards': 'Gule kort pr. kamp',
        ballpossession: 'Boldbesiddelse',
        distance: 'Meter løbet',
        draw: 'Uafgjort',
        'draw.short': 'U',
        'eventsStats.aerialDuels.percentage': 'Luftdueller vundet, %',
        'eventsStats.aerialDuels.total': 'Luftdueller',
        'eventsStats.aerialDuels.won': 'Luftdueller vundet',
        'eventsStats.assists': 'Assists',
        'eventsStats.ballsWon': 'Bolde vundet',
        'eventsStats.blocks': 'Blokeringer',
        'eventsStats.chancesCreated': 'Chancer skabt',
        'eventsStats.cleanSheets': 'Rent bur',
        'eventsStats.clears': 'Clearinger',
        'eventsStats.cornerKicks': 'Hjørnespark',
        'eventsStats.crossBreakdown.percentage': 'Successfulde indlæg (%)',
        'eventsStats.crossBreakdown.successful': 'Successfulde indlæg',
        'eventsStats.crosses': 'Indlæg',
        'eventsStats.custom.goalsPerMinute': 'Minutter pr. mål',
        'eventsStats.distanceData.averageSpeed': 'Gennemsnitlig hastighed',
        'eventsStats.distanceData.distance': 'Meter løbet',
        'eventsStats.distanceData.sprintAverageLength': 'Gns. sprint distance',
        'eventsStats.distanceData.sprints': 'Antal sprinter',
        'eventsStats.distanceData.sprintsDistance': 'Sprint Distance',
        'eventsStats.distanceData.topSpeed': 'Top hastighed',
        'eventsStats.formation': '',
        'eventsStats.foulsCommitted': 'Frispark begået',
        'eventsStats.foulsSuffered': 'Frispark modtaget',
        'eventsStats.goalMouthBlocks': '',
        'eventsStats.goalPerShot': 'Mål pr. skud',
        'eventsStats.goals': 'Mål',
        'eventsStats.goalsAllowed': 'Mål imod',
        'eventsStats.goalsStats.freeKick': 'Mål på frisspark',
        'eventsStats.goalsStats.header': 'Mål på hovedstød',
        'eventsStats.groundDuels.percentage': 'Dueller vundet (%)',
        'eventsStats.groundDuels.total': 'Dueller',
        'eventsStats.groundDuels.won': 'Dueller vundet',
        'eventsStats.keyPasses': 'Nøgleafleveringer',
        'eventsStats.matchesPlayed': 'Kampe spillet',
        'eventsStats.minutesPlayed': 'Minutter spillet',
        'eventsStats.missedPenalty': 'Brændt straffespark',
        'eventsStats.offsides': 'Offsides',
        'eventsStats.ownGoals': 'Selvmål',
        'eventsStats.passLength.long': 'Lange afleveringer',
        'eventsStats.passLength.short': 'Korte afleveringer',
        'eventsStats.penaltyKicks.goals': 'Mål på straffe',
        'eventsStats.penaltyKicks.shots': 'Straffespark',
        'eventsStats.penaltyKicks.won': 'Fremtvunget straffe',
        'eventsStats.rating': 'Vurdering',
        'eventsStats.redCards': 'Røde kort',
        'eventsStats.saves': 'Redninger',
        'eventsStats.savesPercentage': 'Redningsprocent',
        'eventsStats.score': 'Stilling',
        'eventsStats.shots': 'Skud',
        'eventsStats.shotsFaced': 'Skud imod',
        'eventsStats.shotsOnGoal': 'Skud på mål',
        'eventsStats.shotsOnGoalFaced': 'Skud på mål imod',
        'eventsStats.substitutionsIn': 'Ind',
        'eventsStats.substitutionsOut': 'Ud',
        'eventsStats.tackles': 'Tacklinger',
        'eventsStats.totalDuels.won': 'Dueller vundet',
        'eventsStats.touches.blocks': 'Blokeringer',
        'eventsStats.touches.completedPasses': 'Succesfulde afleveringer',
        'eventsStats.touches.completionPercentage': 'Succesfulde afleveringer (%)',
        'eventsStats.touches.interceptions': 'Bolderobringer',
        'eventsStats.touches.passes': 'Afleveringer',
        'eventsStats.touches.passesReceived': 'Modtaget afleveringer',
        'eventsStats.touches.total': 'Berøringer',
        'eventsStats.yellowCards': 'Gule kort',
        'f1.incident.out': '',
        'f1.table.comment': '',
        'f1.table.diff': '<empty>',
        'f1.table.driverName': 'Kører',
        'f1.table.driverNumber': '<empty>',
        'f1.table.gap': 'Gap',
        'f1.table.gap10': 'Gap 10',
        'f1.table.gap15': 'Gap 15',
        'f1.table.in_pit': 'In pit',
        'f1.table.laps': 'Omg.',
        'f1.table.out': 'OUT',
        'f1.table.pits': 'Pit',
        'f1.table.pos': 'Pos',
        'f1.table.q1': 'Q1',
        'f1.table.q2': 'Q2',
        'f1.table.q3': 'Q3',
        'f1.table.teamShortName': 'Hold',
        'f1.table.time': 'Tid',
        'f1.table.tyre': 'Dæk',
        'final.result': 'Slutresultat',
        finished: 'Slut',
        form: 'Form',
        goal: 'Mål',
        goals: 'Mål',
        'goals.short': 'M',
        goalsAverage: 'Mål pr. kamp',
        goalsConceded: 'Mål indkasseret',
        goalsScored: 'Mål scoret',
        ht: 'HT',
        in: 'Ind',
        'km/h': 'km/h',
        live: 'Live',
        'loss.short': 'T',
        matches: 'Kampe',
        'matches.short': 'K',
        matchstart: 'Kampstart',
        'maxStats.distanceData.topSpeed': 'Topfart',
        'meters.short': 'm',
        min: 'min',
        name: 'Navn',
        new: 'Ny',
        'notPlayed.short': '-',
        odds: 'Odds',
        out: 'Ud',
        owngoal: 'Selvmål',
        penalty: 'Mål på straffe',
        points: 'Point',
        'points.short': 'P',
        rank: 'Rang',
        red_card: 'Rødt kort',
        round: 'Runde',
        'round.n': 'Runde {0}',
        scoring: 'Scorings %',
        'shots.on.goal': 'Skud mod mål',
        'stats.position.1': 'Målmænd',
        'stats.position.2': 'Angriber',
        'stats.position.3': 'Midtbane',
        'stats.position.4': 'Forsvar',
        'status.full.cancelled': 'Aflyst',
        'status.full.finished': 'Slutresultat',
        'status.full.inprogress': 'Live',
        'status.full.postponed': 'Udsat',
        'status.short.cancelled': 'Aflyst',
        'status.short.finished': 'FT',
        'status.short.inprogress': 'LIVE',
        'status.short.notstarted': 'Ikke startet',
        'status.short.postponed': 'Udsat',
        subs: 'Udskiftning',
        topSpeed: 'Top hastighed',
        vs: 'vs',
        'win.short': 'V',
        yellow_card: 'Gult kort',
    },
    de: {
        '%': '%',
        Defender: 'Abwehrspieler',
        Forward: 'Stürmer',
        Goalkeeper: 'Torwart',
        Midfielder: 'Mittelfeldspieler',
        all: 'Alle',
        assist: 'Assist',
        assists: 'Assists',
        at: 'bei',
        averageShots: 'Schüsse pro Spiel',
        'averageStats.aerialDuels.percentage': 'Luftkämpfe, % pro Spiel',
        'averageStats.aerialDuels.total': 'Luftkämpfe pro Spiel',
        'averageStats.aerialDuels.won': 'Luftkämpfe gewonnen',
        'averageStats.assists': 'Assists pro Spiel',
        'averageStats.ballsWon': 'Gewonnene Zweikämpfe pro Spiel',
        'averageStats.blocks': 'Abgewehrte Bälle pro Spiel',
        'averageStats.catches': 'Gefangene Bälle pro Spiel',
        'averageStats.chancesCreated': 'Erzielte Chancen',
        'averageStats.clears': 'Abgewehrt pro Spiel',
        'averageStats.cornerKicks': 'Eckbälle pro Spiel',
        'averageStats.crossBreakdown.percentage': 'Erfolgreiche Querpässe in % pro Spiel',
        'averageStats.crossBreakdown.successful': 'Erfolgreiche Querpässe pro Spiel',
        'averageStats.crosses': 'Querpässe pro Spiel',
        'averageStats.distanceData.averageSpeed': 'Durchschnittsgeschwindigkeit',
        'averageStats.distanceData.distance': 'Zurückgelegte Distanz pro Spiel',
        'averageStats.distanceData.sprintAverageLength': 'Durchschnittliche Sprintlänge pro Spiel',
        'averageStats.distanceData.sprints': 'Sprints pro Spiel',
        'averageStats.distanceData.sprintsDistance': 'Sprintlänge pro Spiel',
        'averageStats.distanceData.topSpeed': 'Höchstgeschwindigkeit pro Spiel',
        'averageStats.foulsCommitted': 'Andere pro Spiel gefoult',
        'averageStats.foulsSuffered': 'Gefoult worden pro SpielSpiel',
        'averageStats.goalPerShot': 'Torschüsse pro Spiel',
        'averageStats.goals': 'Tore pro Spiel',
        'averageStats.goalsAllowed': 'Gegentore pro Spiel',
        'averageStats.groundDuels.percentage': 'Zweikämpfe am Boden in % pro Spiel',
        'averageStats.groundDuels.total': 'Zweikämpfe am Boden pro Spiel',
        'averageStats.groundDuels.won': 'Gewonnen Zweikämpfe am Boden',
        'averageStats.keyPasses': 'Wichtige Pässe pro Spiel',
        'averageStats.matchesPlayed': 'Einsätze',
        'averageStats.minutesPlayed': 'Minuten pro Spiel',
        'averageStats.missedPenalty': 'Verschossene Elfer pro Spiel',
        'averageStats.offsides': 'Abseits pro Spiel',
        'averageStats.ownGoals': 'Eigentore pro Spiel',
        'averageStats.passLength.long': 'Lange Pässe pro Spiel',
        'averageStats.passLength.short': 'Kurzpässe pro Spiel',
        'averageStats.penaltyKicks.goals': 'Verwandelte Elfer pro Spiel',
        'averageStats.penaltyKicks.shots': 'Geschossene Elfer pro Spiel',
        'averageStats.penaltyKicks.won': 'Erzielte Elfer pro Spiel',
        'averageStats.possessionAdvanced': 'Ballbesitz pro Spiel',
        'averageStats.rating': 'Rating pro Spiel',
        'averageStats.redCards': 'Rote Karten pro Spiel',
        'averageStats.saves': 'Gehalten pro Spiel',
        'averageStats.savesPercentage': 'Gehalten in % pro Spiel',
        'averageStats.score': 'Getroffen pro Spiel',
        'averageStats.shots': 'Schüsse pro Spiel',
        'averageStats.shotsFaced': 'Schüsse der Gegner ',
        'averageStats.shotsOnGoal': 'Schüsse aufs Tor pro Spiel',
        'averageStats.shotsOnGoalFaced': 'Torschüsse vom Gegner pro Spiel',
        'averageStats.substitutionsIn': 'Einwechslungen',
        'averageStats.substitutionsOut': 'Auswechslungen',
        'averageStats.tackles': 'Tackles pro Spiel',
        'averageStats.touches.blocks': 'Abgewehrt pro Spiel',
        'averageStats.touches.completedPasses': 'Erfolgr. Pässe pro Spiel',
        'averageStats.touches.completionPercentage': 'Erfolgreiche Pässe pro Spiel in %',
        'averageStats.touches.interceptions': 'Unterbrechungen pro Spiel',
        'averageStats.touches.passes': 'Pässe pro Spiel',
        'averageStats.touches.passesReceived': 'Erhaltene Pässe pro Spiel',
        'averageStats.touches.total': 'Ballkontakte pro Spiel',
        'averageStats.yellowCards': 'Gelbe Karten pro Spiel',
        ballpossession: 'Ballbesitz',
        distance: 'Entfernungen',
        'draw.short': 'U',
        'eventsStats.aerialDuels.percentage': 'Luftkämpfe, %',
        'eventsStats.aerialDuels.total': 'Luftkämpfe',
        'eventsStats.aerialDuels.won': 'Gewonnene Luftkämpfe',
        'eventsStats.assists': 'Assists',
        'eventsStats.ballsWon': 'Gewonnene Bälle',
        'eventsStats.blocks': 'Abgewehrt',
        'eventsStats.chancesCreated': 'Chancen erkämpft',
        'eventsStats.cleanSheets': 'Ohne Gegentore',
        'eventsStats.clears': 'Geklärt',
        'eventsStats.cornerKicks': 'Ecken',
        'eventsStats.crossBreakdown.percentage': 'Erfolgreiche Querpässe in %',
        'eventsStats.crossBreakdown.successful': 'Erfolgreiche Querpässe',
        'eventsStats.crosses': 'Querpässe',
        'eventsStats.custom.goalsPerMinute': 'Tore pro Minute',
        'eventsStats.distanceData.averageSpeed': 'Durchschnittsgeschwindigkeit',
        'eventsStats.distanceData.distance': 'Gelaufene Strecke',
        'eventsStats.distanceData.sprintAverageLength': 'Durchschnittliche Sprintlänge',
        'eventsStats.distanceData.sprints': 'Sprints',
        'eventsStats.distanceData.sprintsDistance': 'Sprint Distanz',
        'eventsStats.distanceData.topSpeed': 'Höchstgeschwindigkeit',
        'eventsStats.foulsCommitted': 'Gepfiffene Fouls',
        'eventsStats.foulsSuffered': 'Gefoult worden',
        'eventsStats.goalPerShot': 'Tore pro Schuss',
        'eventsStats.goals': 'Tore',
        'eventsStats.goalsAllowed': 'Tore verhindert',
        'eventsStats.goalsStats.freeKick': 'Tore aus Freistössen',
        'eventsStats.goalsStats.header': 'Kopfballtore',
        'eventsStats.groundDuels.percentage': 'Bodenduelle in %',
        'eventsStats.groundDuels.total': 'Bodenduelle',
        'eventsStats.groundDuels.won': 'Gewonnene Bodenduelle',
        'eventsStats.keyPasses': 'Wichtige Pässe',
        'eventsStats.matchesPlayed': 'Spiele gespielt',
        'eventsStats.minutesPlayed': 'Minuten gespielt',
        'eventsStats.missedPenalty': 'Verschossene Elfmeter',
        'eventsStats.offsides': 'Abseits',
        'eventsStats.ownGoals': 'Eigentore',
        'eventsStats.passLength.long': 'Lange Pässe',
        'eventsStats.passLength.short': 'Kurzpässe',
        'eventsStats.penaltyKicks.goals': 'Tore per Elfmeter erzielt',
        'eventsStats.penaltyKicks.shots': 'Schüsse vom Elfmeterpunkt',
        'eventsStats.penaltyKicks.won': 'Elfer verschuldet',
        'eventsStats.rating': 'Rating',
        'eventsStats.redCards': 'Rote Karten',
        'eventsStats.saves': 'Gehalten',
        'eventsStats.savesPercentage': 'Gehalten in %',
        'eventsStats.score': 'Ergebnis',
        'eventsStats.shots': 'Schüsse',
        'eventsStats.shotsFaced': 'Schüsse vom Gegner',
        'eventsStats.shotsOnGoal': 'Schüsse aufs Tor',
        'eventsStats.shotsOnGoalFaced': 'Schüsse aufs eigene Tor',
        'eventsStats.substitutionsIn': 'Wechsel rein',
        'eventsStats.substitutionsOut': 'Wechsel raus',
        'eventsStats.tackles': 'Tackles',
        'eventsStats.totalDuels.won': 'Gewonne Duelle',
        'eventsStats.touches.blocks': 'Abgewehrt',
        'eventsStats.touches.completedPasses': 'Erfolgr. Pässe',
        'eventsStats.touches.completionPercentage': 'Erfolgr. Pässe in %',
        'eventsStats.touches.interceptions': 'Unterbrechung',
        'eventsStats.touches.passes': 'Pässe',
        'eventsStats.touches.passesReceived': 'Erhaltene Pässe',
        'eventsStats.touches.total': 'Berührungen',
        'eventsStats.yellowCards': 'Gelbe Karten',
        'f1.incident.crash': 'CRASH',
        'f1.incident.out': 'RAUS',
        'f1.incident.pitStop': 'BOXENSTOP',
        'f1.incident.retired': 'AUFGEGEBEN',
        'f1.table.comment': 'Kommentar',
        'f1.table.diff': '<empty>',
        'f1.table.driverName': 'Fahrer',
        'f1.table.driverNumber': '<empty>',
        'f1.table.gap': 'Rückstand',
        'f1.table.gap10': 'Rückstand 10',
        'f1.table.gap15': 'Rückstand 15',
        'f1.table.in_pit': 'Boxengasse',
        'f1.table.laps': 'Runden',
        'f1.table.pits': 'Boxenstopps',
        'f1.table.pos': '#',
        'f1.table.q1': 'Q1',
        'f1.table.q2': 'Q2',
        'f1.table.q3': 'Q3',
        'f1.table.teamShortName': 'Team',
        'f1.table.time': 'Zeit',
        'f1.table.tyre': 'Reifen',
        'final.result': 'Endstand',
        finished: 'Endstand',
        form: 'Form',
        goal: 'Tor',
        goals: 'Tore',
        'goals.short': 'T',
        goalsAverage: 'Tor pro Spiel',
        goalsConceded: 'Tore kassiert',
        goalsScored: 'Tore erzielt',
        ht: 'HT',
        in: 'rein',
        'km/h': 'km/h',
        live: 'Live',
        'loss.short': 'V',
        'matches.short': 'S',
        matchstart: 'Matchbeginn',
        'maxStats.distanceData.topSpeed': 'Höchstgeschwindigkeit',
        'meters.short': 'm',
        min: 'min',
        name: 'Name',
        new: 'Neu',
        odds: 'Quoten',
        out: 'raus',
        owngoal: 'Eigentor',
        points: 'Punkte',
        'points.short': 'P',
        rank: 'Platz',
        red_card: 'Rote Karte',
        round: 'Runde',
        'round.n': 'Runde {0}',
        'shots.on.goal': 'Torschüsse',
        'stats.position.1': 'Torwart',
        'stats.position.2': 'Stürmer',
        'stats.position.3': 'Mittelfeldspieler',
        'stats.position.4': 'Abwehrspieler',
        'status.full.cancelled': 'Abgesagt',
        'status.full.finished': 'Endstand',
        'status.full.inprogress': 'Live',
        'status.full.postponed': 'Verlegt',
        'status.short.cancelled': 'ABG',
        'status.short.finished': 'FT',
        'status.short.inprogress': 'LIVE',
        'status.short.postponed': 'VERL',
        subs: 'Auswechslung',
        topSpeed: 'Geschwindigkeiten',
        vs: 'vs',
        'win.short': 'G',
        yellow_card: 'Gelbe Karte',
    },
    en: {
        '%': '%',
        Coach: 'Coach',
        Defender: 'Defender',
        Forward: 'Forward',
        Goalkeeper: 'Goalkeeper',
        Midfielder: 'Midfielder',
        all: 'All',
        assist: 'Assist',
        assists: 'Assists',
        at: 'at',
        attempts: 'Attempts',
        averageShots: 'Shots per match',
        'averageStats.aerialDuels.percentage': 'Areal duels, % per match',
        'averageStats.aerialDuels.total': 'Areal duels per match',
        'averageStats.aerialDuels.won': 'Areal duels won per match',
        'averageStats.assists': 'Assists per match',
        'averageStats.ballsWon': 'Balls won per match',
        'averageStats.blocks': 'Blocks per match',
        'averageStats.catches': 'Catches per match',
        'averageStats.chancesCreated': 'Chances created per match',
        'averageStats.clears': 'Clearances per match',
        'averageStats.cornerKicks': 'Corners per match',
        'averageStats.crossBreakdown.percentage': 'Successful crosses, % per match',
        'averageStats.crossBreakdown.successful': 'Successful crosses per match',
        'averageStats.crosses': 'Crosses per match',
        'averageStats.distanceData.averageSpeed': 'Average speed per match',
        'averageStats.distanceData.distance': 'Distance covered per match',
        'averageStats.distanceData.sprintAverageLength': 'Sprints Av. lenght per match',
        'averageStats.distanceData.sprints': 'Sprints per match',
        'averageStats.distanceData.sprintsDistance': 'Sprints distance per match',
        'averageStats.distanceData.topSpeed': 'Top speed per match',
        'averageStats.foulsCommitted': 'Fouls committed per match',
        'averageStats.foulsSuffered': 'Fouls suffered per match',
        'averageStats.goalPerShot': 'Goals per shot per match',
        'averageStats.goals': 'Goals per match',
        'averageStats.groundDuels.percentage': 'Ground duels, % per match',
        'averageStats.groundDuels.total': 'Ground duels per match',
        'averageStats.groundDuels.won': 'Ground duels won per match',
        'averageStats.keyPasses': 'Key passes per match',
        'averageStats.matchesPlayed': 'Matches played',
        'averageStats.minutesPlayed': 'Minutes per match',
        'averageStats.missedPenalty': 'Missed penalties per match',
        'averageStats.offsides': 'Offsides per match',
        'averageStats.ownGoals': 'Own goals per match',
        'averageStats.passLength.long': 'Long passes per match',
        'averageStats.passLength.short': 'Short passes per match',
        'averageStats.penaltyKicks.goals': 'Penalty kicks Scored per match',
        'averageStats.penaltyKicks.shots': 'Penalty kicks made per match',
        'averageStats.penaltyKicks.won': 'Penalty kicks won per Macht',
        'averageStats.possessionAdvanced': 'Possession advanced per match',
        'averageStats.rating': 'Rating per match',
        'averageStats.redCards': 'Red cards per match',
        'averageStats.saves': 'Saves per match',
        'averageStats.savesPercentage': 'Saves percentage per match',
        'averageStats.score': 'Score per match',
        'averageStats.shots': 'Shots per match',
        'averageStats.shotsFaced': 'Shots faced per match',
        'averageStats.shotsOnGoal': 'Shots on goal per match',
        'averageStats.shotsOnGoalFaced': 'Shots on goal faced per match',
        'averageStats.substitutionsIn': 'Substitutions in',
        'averageStats.substitutionsOut': 'substitutions out',
        'averageStats.tackles': 'Tackles per match',
        'averageStats.touches.blocks': 'Blocks per match',
        'averageStats.touches.completedPasses': 'Suc. passes per match',
        'averageStats.touches.completionPercentage': 'Suc. passes % per match',
        'averageStats.touches.interceptions': 'Interceptions per match',
        'averageStats.touches.passes': 'passes per match',
        'averageStats.touches.passesReceived': 'Received passes per match',
        'averageStats.touches.total': 'Touches per match',
        'averageStats.yellowCards': 'Yellow cards per match',
        ballpossession: 'Ball possession',
        distance: 'Meters covered',
        draw: 'Draw',
        'draw.short': 'D',
        'eventsStats.aerialDuels.percentage': 'Aerial duels, %',
        'eventsStats.aerialDuels.total': 'Aerial duels',
        'eventsStats.aerialDuels.won': 'Aerial duels won',
        'eventsStats.assists': 'Assists',
        'eventsStats.ballsWon': 'Balls won',
        'eventsStats.blocks': 'Blocks ',
        'eventsStats.chancesCreated': 'Chances created',
        'eventsStats.cleanSheets': 'Clean sheets',
        'eventsStats.clears': 'Clearances',
        'eventsStats.cornerKicks': 'Corners',
        'eventsStats.crossBreakdown.percentage': 'Successful crosses, %',
        'eventsStats.crossBreakdown.successful': 'Successful crosses',
        'eventsStats.crosses': 'Crosses',
        'eventsStats.custom.goalsPerMinute': 'Goals per minute',
        'eventsStats.distanceData.averageSpeed': 'Average speed',
        'eventsStats.distanceData.distance': 'Distance covered',
        'eventsStats.distanceData.sprintAverageLength': 'Sprints av. Length',
        'eventsStats.distanceData.sprints': 'Sprints',
        'eventsStats.distanceData.sprintsDistance': 'Sprints Distance',
        'eventsStats.distanceData.topSpeed': 'Top speed',
        'eventsStats.formation': '',
        'eventsStats.foulsCommitted': 'Fouls committed',
        'eventsStats.foulsSuffered': 'Fouls suffered',
        'eventsStats.goalMouthBlocks': '',
        'eventsStats.goalPerShot': 'Goal per shot',
        'eventsStats.goals': 'Goals',
        'eventsStats.goalsAllowed': 'Goals conceded',
        'eventsStats.goalsStats.freeKick': 'Goal on freekick',
        'eventsStats.goalsStats.header': 'Goal from header',
        'eventsStats.groundDuels.percentage': 'Ground duels, %',
        'eventsStats.groundDuels.total': 'Ground duels',
        'eventsStats.groundDuels.won': 'Ground duels won',
        'eventsStats.keyPasses': 'Key passes',
        'eventsStats.matchesPlayed': 'Matches played',
        'eventsStats.minutesPlayed': 'Minutes played',
        'eventsStats.missedPenalty': 'Missed Penalties',
        'eventsStats.offsides': 'Offsides',
        'eventsStats.ownGoals': 'Own goals',
        'eventsStats.passLength.long': 'Long Passes',
        'eventsStats.passLength.short': 'Short passes',
        'eventsStats.penaltyKicks.goals': 'Goals made on penalty',
        'eventsStats.penaltyKicks.shots': 'Shots from penalty',
        'eventsStats.penaltyKicks.won': 'Penalty against',
        'eventsStats.possessionAdvanced': '',
        'eventsStats.rating': 'Rating',
        'eventsStats.redCards': 'Red cards',
        'eventsStats.saves': 'Saves',
        'eventsStats.savesPercentage': 'Saves percentage',
        'eventsStats.score': 'Score',
        'eventsStats.shots': 'Shots',
        'eventsStats.shotsFaced': 'Shots faced',
        'eventsStats.shotsOnGoal': 'Shots on target',
        'eventsStats.shotsOnGoalFaced': 'Shots on goal faced',
        'eventsStats.substitutionsIn': 'Sub in',
        'eventsStats.substitutionsOut': 'Sub out',
        'eventsStats.tackles': 'Tackles',
        'eventsStats.totalDuels.won': 'Duels won',
        'eventsStats.touches.blocks': 'Blocks',
        'eventsStats.touches.completedPasses': 'Suc. Passes',
        'eventsStats.touches.completionPercentage': 'Suc. passes %',
        'eventsStats.touches.interceptions': 'Interception',
        'eventsStats.touches.passes': 'Passes',
        'eventsStats.touches.passesReceived': 'Received passes',
        'eventsStats.touches.total': 'Touches',
        'eventsStats.yellowCards': 'Yellow cards',
        'f1.incident.crash': 'CRASH',
        'f1.incident.out': 'OUT',
        'f1.incident.pitStop': 'PIT-STOP',
        'f1.incident.retired': 'RETIRED',
        'f1.table.comment': 'Comment',
        'f1.table.diff': '<empty>',
        'f1.table.driverName': 'Driver',
        'f1.table.driverNumber': '<empty>',
        'f1.table.gap': 'Gap',
        'f1.table.gap10': 'Gap 10',
        'f1.table.gap15': 'Gap 15',
        'f1.table.in_pit': 'In pit',
        'f1.table.laps': 'Laps',
        'f1.table.out': 'OUT',
        'f1.table.pits': 'Pits',
        'f1.table.pos': 'Pos',
        'f1.table.q1': 'Q1',
        'f1.table.q2': 'Q2',
        'f1.table.q3': 'Q3',
        'f1.table.teamShortName': 'Team',
        'f1.table.time': 'Time',
        'f1.table.tyre': 'Tyres',
        'final.result': 'Final score',
        finished: 'Finished',
        form: 'Form',
        goal: 'Goal',
        goals: 'Goals',
        'goals.short': 'G',
        goalsAverage: 'Goals per match',
        goalsConceded: 'Goals conceded',
        goalsScored: 'Goals scored',
        ht: 'HT',
        in: 'In',
        'km/h': 'km/h',
        live: 'Live',
        'loss.short': 'L',
        matches: 'Matches',
        'matches.short': 'M',
        matchstart: 'Kickoff',
        'maxStats.distanceData.topSpeed': 'Top speed',
        'meters.short': 'm',
        min: 'min',
        name: 'Name',
        new: 'New',
        'notPlayed.short': ' ',
        odds: 'To win',
        out: 'Out',
        owngoal: 'Own goal',
        penalty: 'Penalty goals',
        points: 'Points',
        'points.short': 'P',
        rank: 'Rank',
        red_card: 'Red card',
        round: 'round',
        'round.n': 'Round {0}',
        scoring: 'Scoring %',
        'shots.on.goal': 'Shots on goal',
        'stats.position.1': 'Goalkeeper',
        'stats.position.2': 'Forward',
        'stats.position.3': 'Midfielder',
        'stats.position.4': 'Defender',
        'status.full.cancelled': 'Cancelled',
        'status.full.finished': 'Final score',
        'status.full.inprogress': 'Live',
        'status.full.postponed': 'Postponed',
        'status.short.cancelled': 'CAN',
        'status.short.finished': 'FT',
        'status.short.inprogress': 'Live',
        'status.short.notstarted': 'Not started',
        'status.short.postponed': 'PPND',
        subs: 'Sub.',
        topSpeed: 'Top speed',
        vs: 'vs',
        'win.short': 'W',
        yellow_card: 'Yellow card',
    },
    fi: {
        '%': '%',
        Defender: 'Puolustaja',
        Forward: 'Hyökkääjä',
        Goalkeeper: 'Maalivahti',
        Midfielder: 'Keskikenttä',
        all: 'Kaikki',
        assist: 'Syöttö',
        assists: 'Syötöt',
        at: 'on',
        averageShots: 'Laukausta per ottelu',
        'averageStats.aerialDuels.percentage': 'Kaksintaistoa ilmassa % per ottelu',
        'averageStats.aerialDuels.total': 'Kaksintaistoa ilmassa per ottelu',
        'averageStats.aerialDuels.won': 'Kaksintaistoa ilmassa voitettu per ottelu',
        'averageStats.assists': 'Syötöt yhteensä',
        'averageStats.ballsWon': 'Voitettua palloa yhteensä',
        'averageStats.blocks': 'Taklausta yhteensä',
        'averageStats.catches': 'Torjuttua maalia yhteensä',
        'averageStats.chancesCreated': 'Maalipaikkaa  yhteensä',
        'averageStats.clears': 'Katkoa yhteensä',
        'averageStats.cornerKicks': 'Kulmia yhteensä',
        'averageStats.crossBreakdown.percentage': 'Onnistunutta keskitystä % yhteensä',
        'averageStats.crossBreakdown.successful': 'Onnistunutta keskitystä yhteensä',
        'averageStats.crosses': 'Keskitystä yhteensä',
        'averageStats.distanceData.averageSpeed': 'Vauhti per ottelu keskimäärä',
        'averageStats.distanceData.distance': 'Kuljettu matka per ottelu',
        'averageStats.distanceData.sprintAverageLength': 'Sprinttiosuus per ottelu keskimäärä',
        'averageStats.distanceData.sprints': 'Sprinttiä per ottelu',
        'averageStats.distanceData.sprintsDistance': 'Sprinttimatka per ottelu',
        'averageStats.distanceData.topSpeed': 'Maksimivauhti per ottelu',
        'averageStats.foulsCommitted': 'Rikkeitä tehty per ottelu',
        'averageStats.foulsSuffered': 'Rikkeitä per ottelu',
        'averageStats.goalPerShot': 'Maalia per laukaus per ottelu',
        'averageStats.goals': 'Maalia per ottelu',
        'averageStats.goalsAllowed': 'Päästetyt maalit per ottelu',
        'averageStats.groundDuels.percentage': 'Kaksintaistoa % maassa',
        'averageStats.groundDuels.total': 'Kaksintaistoa maassa per ottelu',
        'averageStats.groundDuels.won': 'Kaksintaistoa maassa voitettu per ottelu',
        'averageStats.keyPasses': 'Ratkaisevaa syöttöä per ottelu',
        'averageStats.matchesPlayed': 'Ottelua pelattu',
        'averageStats.minutesPlayed': 'Minuuttia per ottelu',
        'averageStats.missedPenalty': 'Ohi laukaistua rangaistuspotkua per ottelu',
        'averageStats.offsides': 'Paitsiota per ottelu',
        'averageStats.ownGoals': 'Omaa maalia per ottelu',
        'averageStats.passLength.long': 'Pitää syöttöä per ottelu',
        'averageStats.passLength.short': 'Lyhyttä syöttöä per ottelu',
        'averageStats.penaltyKicks.goals': 'Rangaistuspotkua osuttu per ottelu',
        'averageStats.penaltyKicks.shots': 'Rangaistuspotkua per ottelu ',
        'averageStats.penaltyKicks.won': 'Rangaistuspotkua voitettu per ottelu',
        'averageStats.possessionAdvanced': 'Pallonhallinta per ottelu',
        'averageStats.rating': 'Ottelutilasto',
        'averageStats.redCards': 'Punaista korttia yhteensä',
        'averageStats.saves': 'Torjuttua maalia yhteensä',
        'averageStats.savesPercentage': 'Torjuttua % maalia yhteensä',
        'averageStats.score': 'Maalia yhteensä',
        'averageStats.shots': 'Laukausta yhteensä',
        'averageStats.shotsFaced': 'Laukausta vastaanotettu yhteensä',
        'averageStats.shotsOnGoal': 'Laukausta kohti maalia per ottelu',
        'averageStats.shotsOnGoalFaced': 'Laukausta kohti maalia vastaanotettu per ottelu',
        'averageStats.substitutionsIn': 'Vaihtoa sisään',
        'averageStats.substitutionsOut': 'Vaihtoa ulos',
        'averageStats.tackles': 'Taklausta per ottelu',
        'averageStats.touches.blocks': 'Vartiointia per ottelu',
        'averageStats.touches.completedPasses': 'Onnistunutta syöttöä per ottelu',
        'averageStats.touches.completionPercentage': 'Onnistunutta % syöttöä per ottelu',
        'averageStats.touches.interceptions': 'Katkoa per ottelu',
        'averageStats.touches.passes': 'Syöttöä per ottelu',
        'averageStats.touches.passesReceived': 'Vastaanotettua syöttöä per ottelu',
        'averageStats.touches.total': 'Pallokontaktia per ottelu',
        'averageStats.yellowCards': 'Keltaista korttia per ottelu',
        ballpossession: 'Pallonhallinta',
        distance: 'Matka',
        'draw.short': 'T',
        'eventsStats.aerialDuels.percentage': 'Kaksintaisto ilmassa %',
        'eventsStats.aerialDuels.total': 'Kaksintaisto ilmassa',
        'eventsStats.aerialDuels.won': 'Kaksintaisto ilmassa voitettu',
        'eventsStats.assists': 'Avustukset',
        'eventsStats.ballsWon': 'Voitettua palloa',
        'eventsStats.blocks': 'Vartiointi',
        'eventsStats.chancesCreated': 'Maalipaikkaa luotu',
        'eventsStats.cleanSheets': 'Kaikki laukaukset torjuttu',
        'eventsStats.clears': 'Torjuttuja',
        'eventsStats.cornerKicks': 'Kulmapotkut',
        'eventsStats.crossBreakdown.percentage': 'Onnistuneet keskitykset %',
        'eventsStats.crossBreakdown.successful': 'Onnistuneet keskitykset',
        'eventsStats.crosses': 'Keskitykset',
        'eventsStats.custom.goalsPerMinute': 'Maalia per minuutti',
        'eventsStats.distanceData.averageSpeed': 'Vauhti keskimäärin',
        'eventsStats.distanceData.distance': 'Juoksettu matka',
        'eventsStats.distanceData.sprintAverageLength': 'Sprintti keskimäärin',
        'eventsStats.distanceData.sprints': 'Sprintit',
        'eventsStats.distanceData.sprintsDistance': 'Sprintti etäisyys',
        'eventsStats.distanceData.topSpeed': 'Maksimivauhti',
        'eventsStats.foulsCommitted': 'Tehdyt rikkeet',
        'eventsStats.foulsSuffered': 'Rikottu',
        'eventsStats.goalPerShot': 'Maaliprosentti',
        'eventsStats.goals': 'Tehdyt maalit',
        'eventsStats.goalsAllowed': 'Päästetyt maalit',
        'eventsStats.goalsStats.freeKick': 'Maalit vapaapotkusta',
        'eventsStats.goalsStats.header': 'Pukatut maalit',
        'eventsStats.groundDuels.percentage': 'Kaksintaistoa maalla %',
        'eventsStats.groundDuels.total': 'Kaksintaistoa maalla',
        'eventsStats.groundDuels.won': 'Kaksintaistoa maalla voitettu',
        'eventsStats.keyPasses': 'Ratkaisevaa syöttöä',
        'eventsStats.matchesPlayed': 'Pelattua ottelua',
        'eventsStats.minutesPlayed': 'Minuuttia pelattu',
        'eventsStats.missedPenalty': 'Ohi lauottua rangaistuspotkua',
        'eventsStats.offsides': 'Paitsiota',
        'eventsStats.ownGoals': 'Omaa maalia',
        'eventsStats.passLength.long': 'Pitkää syöttöä',
        'eventsStats.passLength.short': 'Lyhyttä syöttöä',
        'eventsStats.penaltyKicks.goals': 'Rangaistuspotkumaalit',
        'eventsStats.penaltyKicks.shots': 'Rangaistuspotkut',
        'eventsStats.penaltyKicks.won': 'Rangaistuspotkua vastaan',
        'eventsStats.rating': 'Sijoitus',
        'eventsStats.redCards': 'Punaista korttia',
        'eventsStats.saves': 'Torjunnat',
        'eventsStats.savesPercentage': 'Torjuntaprosentti',
        'eventsStats.score': 'Pisteet',
        'eventsStats.shots': 'Laukaukset',
        'eventsStats.shotsFaced': 'Vastaanotetut laukaukset',
        'eventsStats.shotsOnGoal': 'Laukaukset maalia kohti',
        'eventsStats.shotsOnGoalFaced': 'Laukaukset vastaanotettu',
        'eventsStats.substitutionsIn': 'Vaihto sisään ',
        'eventsStats.substitutionsOut': 'Vaihto ulos',
        'eventsStats.tackles': 'Taklausta',
        'eventsStats.totalDuels.won': 'Voitettu kaksintaisto',
        'eventsStats.touches.blocks': 'Blokkaukset',
        'eventsStats.touches.completedPasses': 'Onnistuneet syötöt',
        'eventsStats.touches.completionPercentage': 'Onnistuneet syötöt %',
        'eventsStats.touches.interceptions': 'Torjunnat',
        'eventsStats.touches.passes': 'Syötöt',
        'eventsStats.touches.passesReceived': 'Vastaanotetut syötöt',
        'eventsStats.touches.total': 'Kosketukset',
        'eventsStats.yellowCards': 'Keltaiset kortit',
        'f1.incident.crash': 'KOLARI',
        'f1.incident.out': 'ULKONA',
        'f1.incident.pitStop': 'VARIKKOPYSÄHDYS',
        'f1.incident.retired': 'KESKEYTTÄNYT',
        'f1.table.comment': 'Kommentti',
        'f1.table.diff': '<empty>',
        'f1.table.driverName': 'Kuski',
        'f1.table.driverNumber': '<empty>',
        'f1.table.gap': 'Etäisyys',
        'f1.table.gap10': 'Etäisyys 10',
        'f1.table.gap15': 'Etäisyys 15',
        'f1.table.in_pit': 'Varikolla',
        'f1.table.laps': 'Kierroksia',
        'f1.table.pits': 'Varikkokäynnit',
        'f1.table.pos': '#',
        'f1.table.q1': 'Q1',
        'f1.table.q2': 'Q2',
        'f1.table.q3': 'Q3',
        'f1.table.teamShortName': 'Tiimi',
        'f1.table.time': 'Aika',
        'f1.table.tyre': 'Renkaat',
        'final.result': 'Tulos',
        finished: 'Tulos',
        form: 'Otteluhistoria',
        goal: 'Maali',
        goals: 'Maalit',
        'goals.short': 'M',
        goalsAverage: '',
        goalsConceded: 'Päästetyt maalit',
        goalsScored: 'Tehdyt maalit',
        ht: 'HT',
        in: 'Sisään',
        'km/h': 'km/h',
        live: 'Live',
        'loss.short': 'H',
        'matches.short': 'O',
        matchstart: 'Ottelun alku',
        'maxStats.distanceData.topSpeed': 'Maksimivauhti',
        'meters.short': 'm',
        min: 'min',
        name: 'Nimi',
        new: 'Uusi',
        odds: 'Kertoimet',
        out: 'Ulos',
        owngoal: 'Oma maali',
        points: 'Pistettä',
        'points.short': 'P',
        rank: 'Sija',
        red_card: 'Punainen kortti',
        round: 'Kierros',
        'round.n': 'Kierros {0}',
        'shots.on.goal': 'Laukausta maalia kohti',
        'stats.position.1': 'Maalivahti',
        'stats.position.2': 'Hyökkääjä',
        'stats.position.3': 'Keskikenttä',
        'stats.position.4': 'Puolustaja',
        'status.full.cancelled': 'Peruttu',
        'status.full.finished': 'Tulos',
        'status.full.inprogress': 'Live',
        'status.full.postponed': 'Siirretty myöhemmäksi',
        'status.short.cancelled': 'PER',
        'status.short.finished': 'FT',
        'status.short.inprogress': 'LIVE',
        'status.short.postponed': 'Lykätty',
        subs: 'Vaihtopenkki',
        topSpeed: 'Vauhti',
        vs: 'vs',
        'win.short': 'V',
        yellow_card: 'Keltainen kortti',
    },
    no: {
        'averageStats.score': '',
        'averageStats.shots': '',
        draw: '',
        'eventsStats.aerialDuels.total': '',
        'eventsStats.crossBreakdown.successful': '',
        'eventsStats.goalsStats.freeKick': '',
        'eventsStats.groundDuels.percentage': '',
        'eventsStats.keyPasses': '',
        'eventsStats.penaltyKicks.goals': '',
        'f1.table.diff': '<empty>',
        'f1.table.driverNumber': '<empty>',
        'f1.table.gap10': '',
        'f1.table.in_pit': '',
        'f1.table.out': '',
        'f1.table.pos': '',
        'f1.table.q1': 'Q1',
        'f1.table.q2': 'Q2',
        'f1.table.q3': 'Q3',
        finished: 'Slut',
        ht: 'HT',
        live: 'Live',
        'maxStats.distanceData.topSpeed': '',
        name: '',
    },
    se: {
        '%': '%',
        Coach: 'Coach',
        Defender: 'Försvarare',
        Forward: 'Angripare',
        Goalkeeper: 'Målvakt',
        Midfielder: 'Mittfältare',
        all: 'Alt',
        assist: 'Assist',
        assists: 'Assists',
        at: 'klockan',
        attempts: 'Försök',
        averageShots: 'Skott per match',
        'averageStats.assists': 'Assists per match',
        'averageStats.blocks': 'Blockeringar per match',
        'averageStats.cornerKicks': 'Hörna per match',
        'averageStats.crosses': 'Cross per match',
        'averageStats.distanceData.sprints': 'Sprintar per match',
        'averageStats.distanceData.topSpeed': 'Toppfart per match',
        'averageStats.foulsCommitted': 'Regelbrott per match',
        'averageStats.foulsSuffered': 'Regelbrott inför per match',
        'averageStats.goalPerShot': 'Mål per skott per match',
        'averageStats.goals': 'Mål per match',
        'averageStats.matchesPlayed': 'Spelade Matcher',
        'averageStats.minutesPlayed': 'Minuter per match',
        'averageStats.offsides': 'Offside per match',
        'averageStats.ownGoals': 'Självmål per match',
        'averageStats.redCards': 'Rött kort per match',
        'averageStats.saves': 'Räddning per match',
        'averageStats.savesPercentage': 'Rädda procentandelar per match',
        'averageStats.shots': 'Skott per match',
        'averageStats.shotsOnGoal': 'Skott på mål per match',
        'averageStats.shotsOnGoalFaced': 'Skott på mål inför per match',
        'averageStats.substitutionsIn': 'Byten i',
        'averageStats.substitutionsOut': 'Byten ut',
        'averageStats.tackles': ' Tacklar per match',
        'averageStats.touches.blocks': 'Blockeringar per match',
        'averageStats.touches.passes': 'Pass per match',
        'averageStats.touches.passesReceived': ' Mottagna pass per match',
        'averageStats.yellowCards': 'Gult kort per match',
        ballpossession: 'Bollinnehav',
        draw: 'Oavgjort',
        'draw.short': 'O',
        'eventsStats.assists': 'Assists',
        'eventsStats.blocks': 'Blockeringar',
        'eventsStats.chancesCreated': 'Chanser skapade',
        'eventsStats.cleanSheets': 'Hålla nollan',
        'eventsStats.cornerKicks': 'Hörna',
        'eventsStats.crossBreakdown.percentage': ' Framgångsrika kors, %',
        'eventsStats.crossBreakdown.successful': ' Framgångsrika kors',
        'eventsStats.crosses': 'Cross',
        'eventsStats.custom.goalsPerMinute': 'Mål per minut',
        'eventsStats.distanceData.averageSpeed': 'Genomsnittshastighet',
        'eventsStats.distanceData.distance': ' Distans täckt',
        'eventsStats.distanceData.sprints': 'Sprintar',
        'eventsStats.distanceData.topSpeed': 'Toppfart',
        'eventsStats.foulsCommitted': 'Antal regelbrott',
        'eventsStats.foulsSuffered': 'Antal regelbrott inför',
        'eventsStats.goalPerShot': 'Mål per skott',
        'eventsStats.goals': 'Mål',
        'eventsStats.goalsAllowed': 'Insläppta mål per match',
        'eventsStats.goalsStats.freeKick': 'Mål på frispark',
        'eventsStats.goalsStats.header': 'Mål på header',
        'eventsStats.groundDuels.percentage': ' Ground dueller, %',
        'eventsStats.groundDuels.total': ' Ground dueller',
        'eventsStats.groundDuels.won': ' Ground dueller vann',
        'eventsStats.keyPasses': ' Key passerar',
        'eventsStats.matchesPlayed': 'Spelade Matcher',
        'eventsStats.minutesPlayed': 'Minuter spelas',
        'eventsStats.missedPenalty': 'Missade straff',
        'eventsStats.offsides': 'Offside',
        'eventsStats.ownGoals': 'Självmål',
        'eventsStats.passLength.long': ' Långa pass',
        'eventsStats.passLength.short': ' Korta passerar',
        'eventsStats.penaltyKicks.goals': ' Mål på straff',
        'eventsStats.penaltyKicks.shots': ' Skott från straff',
        'eventsStats.penaltyKicks.won': ' Straff mot',
        'eventsStats.redCards': 'Rött kort',
        'eventsStats.saves': 'Räddninger',
        'eventsStats.savesPercentage': 'Räddning %',
        'eventsStats.score': 'Resultat',
        'eventsStats.shots': 'Skott',
        'eventsStats.shotsFaced': 'Skott inför',
        'eventsStats.shotsOnGoal': 'Försök',
        'eventsStats.shotsOnGoalFaced': 'Skott på mål inför',
        'eventsStats.substitutionsIn': 'Byte i',
        'eventsStats.substitutionsOut': 'Byte ut',
        'eventsStats.tackles': 'Tacklingar',
        'eventsStats.totalDuels.won': 'Dueller vann',
        'eventsStats.touches.blocks': 'Blockeringar',
        'eventsStats.touches.interceptions': 'Uppfångande',
        'eventsStats.touches.passes': 'Pass',
        'eventsStats.touches.passesReceived': 'Mottagna pass',
        'eventsStats.yellowCards': 'Gult kort',
        'f1.incident.out': 'UT',
        'f1.table.out': 'UT',
        'final.result': 'Slutresultat',
        finished: 'SLUT',
        form: 'Form',
        goal: 'Mål',
        goals: 'Mål',
        'goals.short': 'M',
        goalsAverage: 'Mål per match',
        goalsConceded: 'Insläppta mål per match',
        goalsScored: 'Gjorda mål',
        ht: 'HT',
        in: 'I',
        'km/h': 'km/t',
        live: 'Live',
        'loss.short': 'F',
        matches: 'Matcher',
        'matches.short': 'M',
        matchstart: 'Avspark',
        'maxStats.distanceData.topSpeed': 'Toppfart',
        'meters.short': 'm',
        min: 'min',
        name: 'Namn',
        new: 'Ny',
        odds: 'ATT VINNA?',
        out: 'Ut',
        owngoal: 'Självmål',
        penalty: 'Straffmål',
        points: 'Poäng',
        'points.short': 'P',
        rank: 'Rank',
        rcards: 'Rött kort',
        red_card: 'Rött kort',
        round: 'Omgång',
        'round.n': 'Omgång {0}',
        scoring: 'Scoring %',
        'shots.on.goal': 'Skott på mål',
        'stats.position.1': 'Målvakt',
        'stats.position.2': 'Angripare',
        'stats.position.3': 'Mittfältare',
        'stats.position.4': 'Försvarare',
        'status.full.cancelled': 'AVBOKAD',
        'status.full.finished': 'Slutresultat',
        'status.full.inprogress': 'Live',
        'status.full.postponed': 'Uppskjutet',
        'status.short.cancelled': 'AVBOKAD',
        'status.short.finished': 'SLUT',
        'status.short.inprogress': 'Live',
        'status.short.notstarted': 'Ej påbörjad',
        'status.short.postponed': 'UPPS',
        subs: 'Byte',
        topSpeed: 'Toppfart',
        vs: 'mot',
        'win.short': 'V',
        ycards: 'Gult kort',
        yellow_card: 'Gult kort',
    },
};



/** WEBPACK FOOTER **
 ** ../src/widgets/i18/i18.Common.js
 **/